import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import Footer from '../component/Footer'; 
import TopNav from '../component/TopNav'; 
import HeroSubscribeBox from '../component/HeroSubscribeBox'; 

@withRouter
@inject("store")
@observer
export default class Subscribe extends Component
{
    
    async componentDidMount()
    {
        const user = await this.props.store.refresh_user();
        // console.log( user );
    }
    
    render()
    {
        const main = <div>
        <TopNav/>
        <HeroSubscribeBox/>
        <Footer/>
    </div>;
        return <DocumentTitle title={this.props.store.appname}>{main}</DocumentTitle>;
    }
}